module.exports = __webpack_public_path__ + "img/lato+lora.54207337.png";